import {ls} from "@/CultureService";
import { PracticeKind } from "@/api-client";

export default function translatePracticeKind(kind: PracticeKind | undefined | null): string {
    const practiceKindOptions = [
        {text: ls.Documents_Practices_PracticeKind_Educational, value: PracticeKind.Educational},
        {text: ls.Documents_Practices_PracticeKind_Work, value: PracticeKind.Work},
    ];

    return practiceKindOptions.find((o) => o.value == kind)!.text
}